<template>
  <span class="tabular-nums">{{ formatted }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  value: number;
}>();

const formatted = computed(() => {
  return props.value.toLocaleString(undefined, {});
});
</script>
